<template>
  <!-- 兑换清单 -->
  <div class="IA_productExChangeCode">
    <van-nav-bar :title="'兑换清单'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true" />
    <div class="content">
      <div class="goods_list"
           :class="hasChanged?'nobtnFooterList':''">
        <div class="goods_box"
             v-for="(item,idx) in orderList"
             :key="idx">
          <div class="goods_body">
            <div class="goods_img">
              <van-image :src="item.pt_bg_url?item.pt_bg_url:require('@assets/img/loading-error.png')"
                         :scale="1"
                         :width="'100%'"></van-image>
            </div>
            <div class="goods_desc">
              <div class="name">{{item.ptname_fullname}}</div>
              <div class="list">
                <div>数量：{{item.outnum}}</div>
                <div>所需积分：{{item.credit}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="orderList.length == 0"
             style="margin-top: 100px; font-size: 17px; text-align: center;">{{$t('module.NoData')}}</div>
      </div>
      <div class="goods_footer"
           :class="hasChanged?'nobtnFooter':''">
        <div class="top">
          <div class="label">合计抵扣积分：</div>
          <div class="point">{{total_credit}}</div>
        </div>
        <div v-if="!hasChanged"
             class="btn">
          <van-button round
                      size="small"
                      plain
                      color="#fd0088"
                      @click="confirmReceipt">确认兑换领取</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import { getExChangeProductByGuid, checkExChangeProductOutByGuid } from '@api/integral.js'
export default {
  data () {
    const guid = this.$route.query.guid
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      guid,
      userInfo,
      orderList: [],
      hasChanged: false
    }
  },
  computed: {
    // 合计抵扣
    total_credit () {
      let to = 0
      this.orderList.forEach(el => {
        to += el.total_credit
      });
      return to
    }
  },
  created () {
    this.guid = this.$route.query.guid
    this.getExChangeProductByGuidData()
  },
  methods: {
    // 确认兑换领取
    confirmReceipt () {
      Dialog.confirm({
        title: this.$t('module.systemhint'),
        message: '您确定要兑换领取该商品吗？',
      }).then(() => {
        checkExChangeProductOutByGuid({
          guid: this.guid,
          username: this.userInfo.username
        }).then(res => {
          if (res.data[0].info)
          {
            Toast.fail(res.data[0].info);
          } else
          {
            Toast.success('领取成功！');
            this.getExChangeProductByGuidData()
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    // 根据guid获取兑换的商品列表
    getExChangeProductByGuidData () {
      getExChangeProductByGuid({
        guid: this.guid
      }).then(res => {
        this.orderList = res.data
        this.hasChanged = res.baseinfo[0] ? res.baseinfo[0].ischange : false
      })
    },
    // 直接回家
    onClickLeft () {
      this.$router.push('/home')
    }
  }

}
</script>

<style lang="less" scoped>
.IA_productExChangeCode {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .content {
    // overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .goods_list {
      height: calc(100% - 170px);
      overflow-y: auto;
      .goods_box {
        padding: 20px;
        margin: 20px;
        background: #ffffff;
        border-radius: 20px;
        .goods_body {
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
          .goods_img {
            // flex: 1;
            width: 30%;
            margin-right: 20px;
          }
          .goods_desc {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
              font-size: 28px;
            }
            .list {
              display: flex;
              justify-content: space-between;
              font-size: 26px;
              color: #ee2d35;
            }
          }
        }
      }
    }
    .nobtnFooterList {
      height: calc(100% - 90px);
    }
    .goods_footer {
      height: 170px;
      padding: 20px;
      background: #ffffff;
      .top {
        display: flex;
        justify-content: flex-end;
        font-size: 30px;
        color: #ee2d35;
        margin-bottom: 20px;
      }
      .btn {
        width: 100%;
        display: flex;
        justify-content: center;
        .van-button {
          width: 80%;
          font-size: 28px;
        }
      }
    }
    .nobtnFooter {
      height: 90px;
      .top {
        margin-bottom: 0;
      }
    }
  }
}
</style>